import * as types from "./mutation-types";

export default {
  [types.SET_TIPOS_INSTITUICOES](state, payload) {
    state.tipos_instituicoes = payload;
  },
  [types.SET_TIPO_INSTITUICAO](state, payload) {
    state.tipo_instituicao = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  }
};
